let env = require("./../../../env");

export function checkVersion(version) {
  if (version === env.REACT_APP_VERSION) {
    return true;
  } else {
    return false;
  }
}
